import {ACTION_CODE} from './_actionCode';
import {NotificationService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'GET_DETAILS_NOTIFICATION';

export async function getDetails(userData: Record<string, string>) {
    try {
        LoggerService.logInfo('Action - getDetails - Start');

        const getDetailsResult = await NotificationService.getDetails(userData);

        LoggerService.logInfo('Action - getDetails - Success');

        return ResultModel.newSuccessResult(getDetailsResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - getDetails - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récupération du details des notifications',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
